var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAccCreate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_acc-create",
    transform: "translate(-318 -184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 16,
    height: 16,
    transform: "translate(318 184)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M.951,12a.918.918,0,0,1-.675-.277A.917.917,0,0,1,0,11.049V.949A.915.915,0,0,1,.277.276.916.916,0,0,1,.95,0h4.8a.916.916,0,0,1,.674.276A.919.919,0,0,1,6.7.95v1.7h5.961a.946.946,0,0,1,.95.951V8a.456.456,0,0,1-.138.334.441.441,0,0,1-.325.138.458.458,0,0,1-.332-.138A.453.453,0,0,1,12.677,8V3.584H6.7v1.87H8.176v.935H6.7v1.87H8.176v.935H6.7v1.871h2.89a.47.47,0,0,1,.464.461.463.463,0,0,1-.138.333A.443.443,0,0,1,9.59,12H.951m-.017-.935H2.65V9.35H.935Zm0-2.806H2.65V6.544H.935Zm0-2.8H2.65V3.739H.935Zm0-2.806H2.65V.934H.935Zm3.117,8.416H5.767V9.35H4.052Zm0-2.806H5.767V6.544H4.052Zm0-2.8H5.767V3.739H4.052Zm0-2.806H5.767V.934H4.052Zm9.1,10.738a.471.471,0,0,1-.469-.47V12h-.921a.454.454,0,0,1-.333-.138.461.461,0,0,1,0-.659.457.457,0,0,1,.333-.138h.921v-.922a.473.473,0,0,1,.468-.466.445.445,0,0,1,.327.138.452.452,0,0,1,.137.327v.922h.918a.453.453,0,0,1,.328.137.436.436,0,0,1,.141.325.473.473,0,0,1-.466.468h-.922v.918a.464.464,0,0,1-.138.335.437.437,0,0,1-.325.14m-3.032-7V5.454h.935v.935h-.935m0,1.87h.935v.935h-.935Z",
    transform: "translate(318.5 185.306)",
    fill: "#3953fb"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccCreate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accCreate.472ec2dd.svg";
export { ForwardRef as ReactComponent };